import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'
import { log } from '@/libs/Logger.js'

const getSubscriptionServices = () => {
    store.dispatch('startSubscriptionsLoading')

    makeRequest('getSubscriptionServices', {})
        .then(response => {
            if (response?.sucesso && response.data) {
                store.dispatch('setSubscriptionServices', response.data)
            } else {
                log({ type: 'error', message: `Resposta inesperada em getSubscriptionServices: ${JSON.stringify(response)}` })
            }
        })
        .catch(error => {
            log({ type: 'error', message: `Erro em getSubscriptionServices:\n${error.message}` })
        })
        .finally(() => {
            store.dispatch('stopSubscriptionsLoading')
        })
}

const addSubscriptionService = async (services, dependent) => {
    try {
        const response = await makeRequest('addSubscriptionService', { services, dependent })
        if (response?.data?.subscriptionOK) {
            return { error: false }
        }
    } catch (error) {
        log({ type: 'error', message: `Erro em addSubscriptionService:\n${error.message}` })
    }

    return { error: true }
}

const getSubscribedServicesByConsumer = (CDCONSUMIDOR) => {
    store.dispatch('startSubscriptionsLoading')

    makeRequest('getSubscribedServicesByConsumer', { CDCONSUMIDOR })
        .then(response => {
            if (response?.sucesso && response.data) {
                store.dispatch('setSubscribedServicesByConsumer', response.data)
            } else {
                log({ type: 'error', message: `Resposta inesperada em getSubscribedServicesByConsumer: ${JSON.stringify(response)}` })
            }
        })
        .catch(error => {
            log({ type: 'error', message: `Erro em getSubscribedServicesByConsumer:\n${error.message}` })
        })
        .finally(() => {
            store.dispatch('stopSubscriptionsLoading')
        })
}

const hasAnySubscriptionService = () => {
    makeRequest('hasAnySubscriptionService', {})
        .then(response => {
            if (response?.sucesso && response.data !== undefined) {
                store.dispatch('toggleVisibleCards', { id: 'subscriptionServices', value: response.data })
            } else {
                log({ type: 'error', message: `Resposta inesperada em hasAnySubscriptionService: ${JSON.stringify(response)}` })
            }
        })
        .catch(error => {
            log({ type: 'error', message: `Erro em hasAnySubscriptionService:\n${error.message}` })
        })
}

export { getSubscriptionServices, addSubscriptionService, getSubscribedServicesByConsumer, hasAnySubscriptionService }
